<template>
  <div class="p-p-4">
    <div class="p-d-flex">
      <div class="p-mr-6">
        <h4 class="p-text-center">Container type</h4>
        <div v-for="container of containers" :key="container.value.id" class="p-field-radiobutton p-px-2">
          <label :for="container.value.id">
            <Avatar  :image="container.value.imageurl" size="large" class="p-mr-2"/>
          </label>
          <RadioButton :id="container.value.id" name="container" :value="container.value" v-model="newOrder.container" />
          <label :for="container.value.id">{{container.name}}</label>
        </div>
      </div>
      <Divider class="p-mt-6" layout="vertical" />
      <div class="p-ml-6">
        <h4 class="p-text-center">Ønsket leveringsdato</h4>
        <Calendar  v-model="newOrder.deliverydate" inline :disabledDays="[0,6]" :minDate="calendar.minDate" :numberOfMonths="2"/> 
      </div>
    </div>
    <Message v-for="(error, index) in errors" :key="index" severity="error">{{ error }}</Message>
  </div>
</template>

<script>
import RadioButton from 'primevue/radiobutton';
import Message from 'primevue/message';
import Avatar from 'primevue/avatar';
import Calendar from 'primevue/calendar';
import Divider from 'primevue/divider';

export default {
name: 'containerOrder',
components: {
  RadioButton,
  Message,
  Avatar,
  Calendar,
  Divider
},

data(){
  return{
    errors: [],
    newOrder: {
      active: true,
      changeorstop: null,
      comment: '',
      companyname: null,
      container: null,
      containernumber: null,
      createddate: new Date(),
      declarationnumber: null,
      deliverydate: this.$moment().add(1,'days').toDate(),
      gpdeclares: false,
      organizationumber: null,
      projectid: null,
      useremail: null,
      userid: null,
      username: null,
      userphone: null,
      wastetype: null ,
      createdbyadmin: this.isAdmin,
      updateddate: new Date()
    },
    calendar: {
      minDate: this.$moment().add(1,'days').toDate(), 
    },
    
    
  }
},

mounted(){
  /* init default company for new order */
  this.newOrder = {...this.newOrder, ...{
      companyname: this.company.companyname,
      organizationumber: this.company.organizationnumber,
      projectid: this.project.id,
      useremail: this.user.Email,
      userid: this.user.id,
      username: this.user.name,
      phone: this.user.phone,
    }
  }
},

methods: {
  getOrder(){
    this.errors = []
    if(!this.newOrder.organizationumber)
      this.errors.push('Velg en bedrift')
    if(!this.newOrder.userid)
      this.errors.push('Klarte ikke å finne bruker. Prøv å logg ut og inn på nytt.')
    if(!this.newOrder.projectid)
      this.errors.push('Finner ikke prosjektet. Venligst prøv på nytt.')
    if(!this.newOrder.container)
      this.errors.push('Velg container type')


    if(this.errors.length){
      return false
    }
    this.newOrder.createdbyadmin = this.isAdmin 
    return  this.newOrder
  }
},

computed: {
  isAdmin(){
    return this.$store.getters['user/isAdmin']
  },
  project(){
    return this.$store.getters["projects/inspect"]
  },

  company(){
    return this.$store.getters["companies/current"]
  },

  user(){
    return this.$store.getters["user/get"]
  },

  containers(){
    return this.$store.getters["containers/list"].map(item => {
      return{
        value: item, 
        name: `${item.size}${item.measurementunit} ${item.descriptionname}`
      }
    })
  }
}
}
</script>